module.exports = __webpack_public_path__ + "img/GAME_AIRPLANE1.78a6b2c7.jpg";